import { Box } from "@mui/material";
import React from "react";
import { Color } from "../constants";

const borderRadius = "4px";

const FettiProgressBar = ({ pct }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "10px",
        // backgroundColor: Color.fettiLightBlue + "80",
        backgroundColor: "#aaa3",
        borderRadius,
      }}>
      <Box
        sx={{
          width: `${pct}%`,
          height: "100%",
          backgroundColor: Color.primary,
          borderRadius,
          transition: "width 0.2s ease-in-out",
        }}
      />
    </Box>
  );
};

export default FettiProgressBar;
